const ConvertFeetToInch=(feet=0, inch=0)=>{
    return feet*12+inch*1;
}

const ConvertInchToFeetAndInch=(inch=0)=>{
    return [Math.floor(inch / 12),(inch % 12)];
}

export {ConvertFeetToInch, ConvertInchToFeetAndInch}